export function getPercentString(value: number): string {
  return `${(100 * value).toFixed(2)}%`;
}

export function trimTrailingZero(value: number, fractionDigits: number): string {
  return String(parseFloat(value.toFixed(fractionDigits)));
}

export function trimTrailingZeroWithSign(value: number, fractionDigits: number): string {
  const result = trimTrailingZero(value, fractionDigits);
  return value > 0 ? `+${result}` : result;
}

export function durationToString(duration: number): string {
  return `${Math.floor(duration / 60)}:${String(duration % 60).padStart(2, '0')}`;
}
